import React from 'react';
import { Input } from './Input';


export const InputWrapper = (props) => {
    return (
      <div>
      { props.label && <span className="label-before">{props.label}</span> }
      <div className="wrap-input100 validate-input">
      <Input {...props} className="input100"/>
      <span className="focus-input100"></span>
      </div>
      </div>
    )
}